import script from "./MainDesktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainDesktop.vue?vue&type=script&lang=ts&setup=true"

import "./MainDesktop.vue?vue&type=style&index=0&id=1664917c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1664917c"]])

export default __exports__